import { createRootSaga } from '@mwl/core-lib';

export const rootSaga = createRootSaga();
